var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "modal",
    staticClass: "uk-modal-container",
    attrs: {
      "title": _vm.title,
      "auto-overflow": true
    },
    on: {
      "show": _vm.onShow,
      "hide": _vm.onHide,
      "hidden": _vm.onHidden
    }
  }, [_c('file-upload-button', {
    attrs: {
      "attachment-type": _vm.attachmentType,
      "multiple": _vm.multiple
    },
    on: {
      "change": _vm.refetchList
    }
  }), _vm._v(" "), _c('search-input', {
    ref: "search",
    staticClass: "uk-align-right",
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  }), _vm._v(" "), (_vm.gridLoaded) ? _c('data-grid', {
    ref: "dataGrid",
    staticClass: "uk-margin-medium",
    attrs: {
      "table-class": "uk-table-middle",
      "columns": _vm.gridColumns,
      "sortable": ['name', 'updatedAt'],
      "selectable": true,
      "multiple": _vm.multiple,
      "rows": _vm.attachments.entries,
      "sort-info": _vm.attachments.sort,
      "page-info": _vm.attachments.pagination,
      "is-loading": _vm.isLoading,
      "show-actions": false,
      "change-route": false
    },
    on: {
      "change-page": _vm.onChangePage,
      "change-selection": _vm.onChangeSelection,
      "sort": _vm.sortBy
    },
    scopedSlots: _vm._u([{
      key: "beforeRow",
      fn: function(props) {
        return [_c('td', {
          staticClass: "attachment-picker__thumbnail-cell"
        }, [_c('thumbnail', {
          staticClass: "attachment-picker__thumbnail",
          attrs: {
            "attachment": props.row
          }
        })], 1)]
      }
    }, {
      key: "name",
      fn: function(props) {
        return [_c('attachment-name', {
          attrs: {
            "attachment": props.row
          }
        })]
      }
    }, {
      key: "type",
      fn: function(props) {
        return [_vm._v("\n      " + _vm._s(_vm.formatTypeName(props.row.type)) + "\n    ")]
      }
    }, {
      key: "updatedAt",
      fn: function(props) {
        return [_c('timeago', {
          attrs: {
            "since": props.row.updatedAt,
            "auto-update": 60
          }
        })]
      }
    }])
  }, [_c('span', {
    slot: "empty"
  }, [_vm._v(_vm._s(_vm.$t('hints.empty')))]), _vm._v(" "), _c('template', {
    slot: "beforeHead"
  }, [_c('th')])], 2) : _c('div', {
    staticClass: "loader-container uk-container uk-margin-medium-top uk-text-center"
  }, [_c('loader')], 1), _vm._v(" "), _c('common-button', {
    attrs: {
      "text": _vm.$t('actions.select'),
      "type": "primary",
      "disabled": !_vm.hasSelection
    },
    on: {
      "click": _vm.submit
    },
    slot: "buttons"
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea6fc7e8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/AttachmentPicker.vue
// module id = 2136
// module chunks = 0